import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { takeUntil } from 'rxjs/operators';
import { BehaviorSubject } from 'rxjs';
import { Destroyer } from '@apps/tools';
import * as i0 from "@angular/core";
import * as i1 from "@angular/cdk/layout";
export const LAYOUT = {
    xs: 0,
    sm: 576,
    md: 768,
    lg: 992,
    xl: 1200
};
export class LayoutService extends Destroyer {
    constructor(breakpointObserver) {
        super();
        this.stateSubject = new BehaviorSubject([]);
        this.state$ = this.stateSubject.asObservable();
        this.widthSubject = new BehaviorSubject(undefined);
        this.width$ = this.widthSubject.asObservable();
        Object.keys(Breakpoints).forEach(key => {
            breakpointObserver
                .observe(Breakpoints[key])
                .pipe(takeUntil(this.destroy$))
                .subscribe(e => this.updateState(key, e.matches));
        });
        breakpointObserver
            .observe(`(max-width: ${LAYOUT.sm - 1}px)`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(e => this.updateWidth('xs', e.matches));
        breakpointObserver
            .observe(`(min-width: ${LAYOUT.sm}px) and (max-width: ${LAYOUT.md - 1}px)`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(e => this.updateWidth('sm', e.matches));
        breakpointObserver
            .observe(`(min-width: ${LAYOUT.md}px) and (max-width: ${LAYOUT.lg - 1}px)`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(e => this.updateWidth('md', e.matches));
        breakpointObserver
            .observe(`(min-width: ${LAYOUT.lg}px) and (max-width: ${LAYOUT.xl - 1}px)`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(e => this.updateWidth('lg', e.matches));
        breakpointObserver
            .observe(`(min-width: ${LAYOUT.xl}px)`)
            .pipe(takeUntil(this.destroy$))
            .subscribe(e => this.updateWidth('lg', e.matches));
    }
    updateState(name, add) {
        const value = this.stateSubject.getValue();
        if (add && value.findIndex(e => e === name) === -1) {
            value.push(name);
        }
        if (!add && value.findIndex(e => e === name) !== -1) {
            const index = value.findIndex(e => e === name);
            value.splice(index, 1);
        }
        this.stateSubject.next(value);
    }
    updateWidth(name, add) {
        if (add) {
            this.widthSubject.next(name);
        }
    }
}
LayoutService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function LayoutService_Factory() { return new LayoutService(i0.ɵɵinject(i1.BreakpointObserver)); }, token: LayoutService, providedIn: "root" });
